<div class="row align-items-center justify-content-center h-100">
    <div class="col-md-6">
        <div class="text-center">
            <h1 [innerText]="'NOT_FOUND.TITLE' | translate"></h1>
            <button type="button" class="btn btn-primary" (click)="goBack()" [innerText]="'GENERAL.BACK' | translate"></button>
        </div>
    </div>
</div>
